import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Theme } from '../../../backend/model/theme.model';
import { ThemeHandlerService } from '../../../idp/service/theme-handler.service';
import { IDLinkModule } from '@inera/ids-angular/components/link';
import { IDFooterIneraAdminComponent } from '@inera/ids-angular/components/footer-inera-admin';
import { IDFooter1177Component } from '@inera/ids-angular/components/footer-1177';
import { IDFooter1177ProComponent } from '@inera/ids-angular/components/footer-1177-pro';
import { IDFooter1177AdminComponent } from '@inera/ids-angular/components/footer-1177-admin';

@Component({
  selector: 'idp-footer',
  imports: [
    CommonModule,
    IDLinkModule,
    IDFooterIneraAdminComponent,
    IDFooter1177Component,
    IDFooter1177ProComponent,
    IDFooter1177AdminComponent
  ],
  templateUrl: './idp-footer.component.html',
  styleUrl: './idp-footer.component.css'
})
export class IdpFooterComponent implements OnInit {
  private themeHandler = inject(ThemeHandlerService);

  public theme: Theme;
  public Math = Math;

  ngOnInit() {
    this.themeHandler.getTheme().subscribe(theme => {
      this.theme = theme?.value?.value;
    });
  }
}
